import * as classNames from 'classnames';
import { DataService } from '../../../services/data_service';
import Geocoder from 'react-map-gl-geocoder';
import { lazyInject } from '../../../services/inversify';
import 'mapbox-gl/dist/mapbox-gl.css';
import * as React from 'react';
import 'react-map-gl-geocoder/dist/mapbox-gl-geocoder.css';
import ReactMapGL, { Marker } from 'react-map-gl';
import style from './map.less';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';

const MAPBOX_TOKEN = 'pk.eyJ1Ijoib2xpdmVyYnVuZGEiLCJhIjoiY2s1bWt2djVzMHhvOTNucGNzZXhrdWFuOSJ9.msxL5i1GigS33y-i3OtYMQ';

interface WMapProps extends React.ClassAttributes<any> {
    lat: number;
    long: number;
    data: any;
    entity: string;
    edittable: boolean;
    onSaveDone?(): void;
}

interface WMapState extends React.ClassAttributes<any> {
    lat: number;
    markerLat: number;
    markerLong: number;
    long: number;
    zoomMap: number;
    events: any;
    showPopup: boolean;
    latNew?: number;
    longNew?: number;
    onFlyAnimation: boolean;
    edittable: boolean;
    showError: boolean;
    errorText: string;
    gpsDaten: Array<any>;
}

export class WMap extends React.Component<WMapProps, WMapState> {

    constructor(props: any) {
        super(props);
        this.state = {
            lat: null,
            markerLat: null,
            long: null,
            markerLong: null,
            zoomMap: 11,
            events: {},
            showPopup: false,
            onFlyAnimation: false,
            edittable: this.props.edittable,
            showError: this.props.data.checkGps ? true : false,
            errorText: this.props.data.checkGps ? 'Es gibt noch keine GPS-Verortung, bitte prüfen Sie die Koordinaten!' : '',
            gpsDaten: []
        };
        this.getLocation = this.getLocation.bind(this);
        this.success = this.success.bind(this);
        this.changeViewPort = this.changeViewPort.bind(this);
        this.customTools = this.customTools.bind(this);
        this.getGpsDaten = this.getGpsDaten.bind(this);
    }

    private mapRef = React.createRef<HTMLDivElement>();
    private geocoderContainerRef = React.createRef<HTMLDivElement>();

    @lazyInject(DataService) private dataService: DataService;

    componentDidMount(): void {
        const { lat, long, data } = this.props;
        const { hausnummer, ort, plz, strasse, checkGps } = data;

        if (lat && long && lat !== 0 && long !== 0) {
            this.getGpsDaten([lat, long]);
            this.setState({
                lat, long, markerLat: lat, markerLong: long, zoomMap: 16
            });
        } else if (hausnummer && ort && plz && strasse) {
            const vollAddress = encodeURIComponent(JSON.stringify(plz + ' ' + ort + ' ' + strasse + ' ' + hausnummer));
            const url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + vollAddress +
                '.json?country=DE&limit=5&language=de&access_token=' + MAPBOX_TOKEN;

            fetch(url)
                .then((res: any) => res.json())
                .then((dataJson: any) => {

                    if (dataJson.features.length === 0) {
                        this.setState({
                            lat: 52.519274979935176,
                            markerLat: 52.519274979935176,
                            long: 13.388504938481557,
                            markerLong: 13.388504938481557,
                            zoomMap: 11,
                            showError: true,
                            errorText: 'Die Address wurde nicht gefunden!'
                        });
                    } else {
                        this.setState({
                            lat: dataJson.features[0].center[1],
                            long: dataJson.features[0].center[0],
                            markerLat: dataJson.features[0].center[1],
                            markerLong: dataJson.features[0].center[0],
                            zoomMap: 16,
                            showError: true,
                            errorText: 'Es gibt noch keine GPS-Verortung, bitte prüfen Sie die Koordinaten!'
                        });
                    }
                });
        } else {
            this.setState({
                lat: 52.519274979935176,
                markerLat: 52.519274979935176,
                long: 13.388504938481557,
                markerLong: 13.388504938481557,
                zoomMap: 11
            });
        }
    }

    changeViewPort(viewport: any, search: boolean): void {
        const { latitude, longitude, zoom } = viewport;
        this.getGpsDaten([latitude, longitude]);

        if (search) {
            this.setState({
                lat: latitude,
                long: longitude,
                markerLat: latitude,
                markerLong: longitude,
                showPopup: true,
                latNew: latitude,
                longNew: longitude,
                zoomMap: zoom,
                onFlyAnimation: true
            });
        } else {
            this.setState({
                lat: latitude,
                long: longitude,
                markerLat: latitude,
                markerLong: longitude,
                zoomMap: zoom,
                onFlyAnimation: false,
                showPopup: false
            });

        }
    }

    convertGps(data: number): string {
        const absDD = Math.abs(data);
        const d = absDD > 0 ? Math.floor(absDD) : Math.ceil(absDD);
        const minfloat = (absDD - d) * 60;
        const m = minfloat > 0 ? Math.floor(minfloat) : Math.ceil(minfloat);
        const secfloat = (minfloat - m) * 60;
        const s = Math.round(secfloat);

        return ('' + d + '°' + m + '\'' + s);
    }

    customTools(): JSX.Element {
        return (
            <div className='mapboxgl-ctrl-top-right'>
                <div className={classNames('mapboxgl-ctrl-group', 'mapboxgl-ctrl', style.focus)}>
                    <button className='mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-in' title='Zoom In'
                        onClick={() => this.setState({ zoomMap: this.state.zoomMap + 1 })}>
                        <span className='mapboxgl-ctrl-icon'></span>
                    </button>
                    <button className='mapboxgl-ctrl-icon mapboxgl-ctrl-zoom-out' title='Zoom Out'
                        onClick={() => this.setState({ zoomMap: this.state.zoomMap - 1 })}>
                        <span className='mapboxgl-ctrl-icon'></span>
                    </button>
                    {this.state.edittable &&
                        <button className={classNames('mapboxgl-ctrl-icon', style.resetKoord)} title='Reset Koordinate'
                            onClick={() => {
                                this.saveData(0, 0);
                                this.setState({ lat: 52.519274979935176, long: 13.388504938481557, zoomMap: 11 });
                            }}>
                            <span className='mapboxgl-ctrl-icon'></span>
                        </button>
                    }
                </div>
            </div>
        );
    }

    getGpsDaten(deg: Array<number>): void {
        const gpsDaten: Array<any> = [];

        deg.forEach((gps: any) => {
            if (gps !== 0) {
                const d = this.convertGps(gps);
                gpsDaten.push(d);
            }

        });
        this.setState({gpsDaten});
    }

    getLocation(): void {
        const options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };
        navigator.geolocation.getCurrentPosition(this.success, (error: any) => console.log(error), options);
    }

    getPopup(lngLat: Array<any>): void {
        this.setState({
            longNew: lngLat[0],
            latNew: lngLat[1]
        });
    }

    render(): JSX.Element {
        const {
            lat, long, zoomMap, showPopup, longNew, latNew, markerLong, markerLat, onFlyAnimation, edittable, showError, errorText,
            gpsDaten
        } = this.state;

        if (!lat && !long) {
            return <WSpinner />;
        }
        const size = 30;
        const ICON = `M20.2,15.7L20.2,15.7c1.1-1.6,1.8-3.6,1.8-5.7c0-5.6-4.5-10-10-10S2,4.5,2,10c0,2,0.6,3.9,1.6,5.4c0,0.1,0.1,0.2,0.2,0.3
                      c0,0,0.1,0.1,0.1,0.2c0.2,0.3,0.4,0.6,0.7,0.9c2.6,3.1,7.4,7.6,7.4,7.6s4.8-4.5,7.4-7.5c0.2-0.3,0.5-0.6,0.7-0.9
                      C20.1,15.8,20.2,15.8,20.2,15.7z`;

        return (
            <div className={style.mapDialogWrapper}>
                {/* <button
                    className={style.textButton}
                    onClick={() => this.getLocation()}
                >
                    Meine GPS Position
                </button> */}
                <div className={style.mapWrapper}>
                    {showError &&
                        <div className={style.errorTextWrapper}>
                            <p>{errorText}</p>
                        </div>
                    }
                    <div
                        ref={this.geocoderContainerRef}
                        className={style.searchBox}
                    >
                    </div>
                    <ReactMapGL
                        width={500}
                        height={500}
                        latitude={lat}
                        longitude={long}
                        zoom={zoomMap}
                        ref={this.mapRef}
                        mapboxApiAccessToken={MAPBOX_TOKEN}
                        onViewportChange={(viewport: any) => this.changeViewPort(viewport, false)}
                        onClick={(e: any) => {
                            if (edittable) {
                                this.getGpsDaten([e.lngLat[1], e.lngLat[0]]);
                                this.setState({ long: e.lngLat[0], lat: e.lngLat[1], markerLong: e.lngLat[0], markerLat: e.lngLat[1] });
                            }
                        }}
                    >
                        {edittable &&
                            <Geocoder
                                mapRef={this.mapRef}
                                placeholder={'Suche'}
                                countries={'DE'}
                                containerRef={this.geocoderContainerRef}
                                onViewportChange={(viewport: any) => this.changeViewPort(viewport, true)}
                                mapboxApiAccessToken={MAPBOX_TOKEN}
                            />
                        }
                        <Marker
                            longitude={markerLong}
                            latitude={markerLat}
                            draggable={edittable ? true : false}
                            onDrag={(e: any) => this.getGpsDaten([e.lngLat[1], e.lngLat[0]])}
                            onDragEnd={(e: any) => {
                                this.getGpsDaten([e.lngLat[1], e.lngLat[0]]);
                                this.setState({
                                    markerLong: e.lngLat[0],
                                    markerLat: e.lngLat[1],
                                    lat: e.lngLat[1],
                                    long: e.lngLat[0]
                                });
                            }}
                        >
                            <svg
                                height={size}
                                viewBox='0 0 24 24'
                                style={{
                                    cursor: 'pointer',
                                    fill: '#d00',
                                    stroke: 'none',
                                    transform: `translate(${-size / 2}px,${-size}px)`
                                }}
                            >
                                <path d={ICON} />
                            </svg>
                        </Marker>
                        {this.customTools()}
                    </ReactMapGL>
                </div>
                <div className={style.infoWrapper}>
                    <p style={{fontSize: '11px', fontWeight: 'bold', color: '#888'}}>
                        GPS-Koordinate:&nbsp;
                        {gpsDaten.length === 0
                            ? 'Nicht vorhanden'
                            : <span>{gpsDaten[0]}, {gpsDaten[1]}</span>
                        }
                    </p>
                    <button
                        className={style.textButton}
                        onClick={() => this.saveData(lat, long)}
                    >
                        Speichern
                    </button>
                </div>
            </div>
        );
    }

    saveData(lat: number, long: number): void {
        const data = this.props.data;
        data.latitude = lat;
        data.longitude = long;

        if (data.standort_tid_orig && typeof data.standort_tid === 'string') {
            data.standort_tid = data.standort_tid_orig;
        }
        this.dataService.saveData(this.props.entity, data, null, null, (success: boolean) => {
            if (success) {
                alert('Koordinate wurde gespeichert.');
                this.setState({ errorText: '', showError: false });
                this.props.onSaveDone();
            } else {
                alert('Koordinate wurde nicht gespeichert!');
            }
        });
    }

    success(pos: any): void {
        this.setState({
            lat: pos.coords.latitude,
            long: pos.coords.longitude,
            latNew: pos.coords.latitude,
            longNew: pos.coords.longitude,
            showPopup: true
        });
    }
}
